export default {
  resourceType: 'Tipo de recurso',
  skills: 'Habilidades',
  keywords: 'Palabras clave',
  crossAreas: 'Áreas cruzadas',
  ageRanges: 'Edad principal',
  secondaryAgeRanges: 'Edad secundaria',
  ods: 'ODS',
  resourceTypePlaceholder: 'Seleccionar tipo de recurso',
  skillsPlaceholder: 'Seleccionar habilidades',
  keywordsPlaceholder: 'Ingresar las palabras clave',
  crossAreasPlaceholder: 'Seleccionar áreas cruzadas',
  primaryAgeRangesPlaceholder: 'Edad principal',
  secondaryAgeRangesPlaceholder: 'Edad secundaria',
  odsPlaceholder: 'Seleccionar ODS',
  errors: {
    resourceType: 'Es necesario seleccionar un tipo de recurso',
    skills: 'Es necesario seleccionar una habilidad',
    crossAreas: 'Es necesario seleccionar un área',
    ageRange: 'Es necesario seleccionar una edad',
    ods: 'Es necesario seleccionar un ODS'
  }
}

export const en = {
  resourceType: 'Type of resource',
  skills: 'Skills',
  keywords: 'Keywords',
  crossAreas: 'Cross areas',
  ageRanges: 'Main age',
  secondaryAgeRanges: 'Secondary age',
  ods: 'SDG',
  resourceTypePlaceholder: 'Select type of resource',
  skillsPlaceholder: 'Select skills',
  keywordsPlaceholder: 'Enter keywords',
  crossAreasPlaceholder: 'Select cross areas',
  primaryAgeRangesPlaceholder: 'Primary age',
  secondaryAgeRangesPlaceholder: 'Secondary age',
  odsPlaceholder: 'Select SDG',
  errors: {
    resourceType: 'You need to select a resource type',
    skills: 'You need to select a skill',
    crossAreas: 'You need to select an area',
    ageRange: 'You need to select an age',
    ods: 'You need to select a SDG'
  }
}

export const ca = {
  resourceType: 'Tipus de recurs',
  skills: 'Habilitats',
  keywords: 'Paraules clau',
  crossAreas: 'Àrees creuades',
  ageRanges: 'Edat primari',
  secondaryAgeRanges: 'Edat secundari',
  ods: 'ODS',
  resourceTypePlaceholder: 'Seleccionar tipus de recurs',
  skillsPlaceholder: 'Seleccionar habilitats',
  keywordsPlaceholder: 'Ingressar les paraules clau',
  crossAreasPlaceholder: 'Seleccionar àrees creuades',
  primaryAgeRangesPlaceholder: 'Edat primari',
  secondaryAgeRangesPlaceholder: 'Edat secundari',
  odsPlaceholder: 'Seleccionar ODS',
  errors: {
    resourceType: 'És necessari seleccionar un tipus de recurs',
    skills: 'És necessari seleccionar una habilitat',
    crossAreas: 'És necessari seleccionar una àrea',
    ageRange: 'És necessari seleccionar una edat',
    ods: 'És necessari seleccionar un ODS'
  }
}
